import React from "react";

// material import
import { Box, Button, Grid2, Typography } from "@mui/material";

// project import
import { useAuth } from "../../authentication/authContext";
import { useNavigate } from "react-router-dom";

const LogOutConfirmation = ({ handleCloseDialog }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    handleCloseDialog();
    navigate("/login");
  };

  return (
    <Box p={3}>
      <Grid2 container align="center">
        <Grid2 item size={{ xs: 12 }}>
          <Typography
            variant="h5"
            sx={{ fontSize: 18, fontWeight: "medium", mb: 5 }}
          >
            {" "}
            Are you sure want to Log Out?
          </Typography>
        </Grid2>
      </Grid2>
      <Grid2 container align="center" spacing={6}>
        <Grid2 item size={{ xs: 6 }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleLogout}
          >
            Yes
          </Button>
        </Grid2>
        <Grid2 item size={{ xs: 6 }}>
          <Button
            variant="contained"
            color="error"
            type="submit"
            onClick={handleCloseDialog}
            size="small"
          >
            No
          </Button>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default LogOutConfirmation;
